import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/settlementManage'

class Store {
  @observable list = []
  @observable total = 0
  @observable current = 1

  @action
  getList = async () => {
    const { current } = this
    let params = {
      page: current,
      per_page: 10
    }
    let {
      data: { total_count, list },
      success
    } = await Api.historyListApi(params)
    if (success) {
      runInAction(() => {
        this.list = list || []
        this.total = +total_count
      })
    }
  }

  @action
  setPagination = current => {
    this.current = current
    this.getList()
  }
}
export default new Store()
